import { useLocation, useOutletContext } from "react-router";
import type { NavSection } from "../shell/nav.js";

/** The phase each screen is built in (docs/BUILD_PLAN.md), so an empty screen says when it fills. */
const PHASE_BY_ROUTE: Record<string, { phase: number; what: string }> = {
  "/field-jobs": {
    phase: 3,
    what: "jobs raised from findings, exports to the Field App, completions",
  },
  "/installs": {
    phase: 4,
    what: "installs this month, right first time by installer, held installs for review",
  },
  "/submissions": {
    phase: 5,
    what: "every outbound item with its twelve gate checks and simulated response",
  },
  "/bilaterals": { phase: 5, what: "drafted requests with completeness against each process" },
  "/reports": {
    phase: 6,
    what: "the baseline, the trend since the first run and the prioritised fix list",
  },
  "/modules": { phase: 6, what: "every module with its state for this tenant and the shared core" },
  "/water-balance": {
    phase: 6,
    what: "the district water balance preview on illustrative figures",
  },
};

/** An empty state for a screen a later phase delivers: honest about what will appear and when (docs/UX.md section 5). */
export function Placeholder() {
  const location = useLocation();
  const { sections } = useOutletContext<{ sections: NavSection[] }>();
  const item = sections.flatMap((s) => s.items).find((i) => i.route === location.pathname);
  const section = sections.find((s) => s.items.some((i) => i.route === location.pathname));
  const info = PHASE_BY_ROUTE[location.pathname];
  return (
    <>
      <div className="head">
        <div>
          <div className="eyebrow">{section?.label ?? "Water Market"}</div>
          <h1>{item?.label ?? "Not found"}</h1>
        </div>
        {item?.tag ? <span className="pill vio">{item.tag}</span> : null}
      </div>
      <section className="card">
        <header>
          <h2>Nothing here yet</h2>
          {info ? <span className="pill info">Phase {info.phase}</span> : null}
        </header>
        <div className="empty">
          {info
            ? `This screen shows ${info.what}. It is built in Phase ${info.phase}.`
            : "This screen is not part of the build."}
        </div>
      </section>
    </>
  );
}
